
    var riot = require('riot')
    //src: starling/src/tags/line-creation-tool.html
riot.tag2('line-creation-tool',
  '<span ref="overlay" class="line-creation-tool_overlay" hidden onmousedown="{handleMouseDown}" onmousemove="{handleMouseMove}" onmouseup="{handleMouseUp}"></span>',
  'line-creation-tool { position: fixed; z-index: 0; top: 0; bottom: 0; right: 0; left: 0; opacity: 0.5; pointer-events: none; } line-creation-tool .line-creation-tool_overlay,[data-is="line-creation-tool"] .line-creation-tool_overlay{ pointer-events: all; position: fixed; top: 0; bottom: 0; right: 0; left: 0; z-index: 0; }',
  '', function(opts) {
'use strict';

var _this = this;

var _relationshipUi = require('lib/relationship-ui');

this.canvas = opts.canvas;

this.handleMouseDown = function (e) {
  _relationshipUi.rui.createNewLineOnCanvas({ x: e.clientX, y: e.clientY, e: e });
};

this.handleMouseMove = function (e) {
  if (_this.canvas.linkDragging) {
    // simulate first click if we're dragging
    _relationshipUi.rui.clickCount = 1;
  }
};

this.handleMouseUp = function (e) {
  _this.hide();
};
this.hide = function () {
  _this.refs.overlay.hidden = true;
};
this.show = function () {
  _this.refs.overlay.hidden = false;
};
});


    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('line-creation-tool')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/line-creation-tool.html
// module id = 763
// module chunks = 0